import React from 'react';
import styled from 'styled-components';
import SuperOpsLoader from '@nile/components/src/Svg/AnimatedSvg/SuperOpsLoader.svg';
import Loading from '@nile/components/src/Svg/AnimatedSvg/Loading.svg';

const PUBLIC_ROUTES = ['#/systray'];

const LoaderWrapper = styled.div`
  svg {
    height: 100px;
    width: 100px;
  }
`;

const getCommonAppLoadCondition = () => {
  return PUBLIC_ROUTES.some((pattern) =>
    window.location.hash.includes(pattern)
  );
};

function AppLoader(props) {
  const { color, opacity, height, width, showLetNav, common = false } = props;
  const DEFAULT_CONDITION = getCommonAppLoadCondition();
  if (common || DEFAULT_CONDITION) {
    return (
      <div className="flex-center full-height">
        <Loading className="w90" />
      </div>
    );
  }
  return (
    <div>
      <div
        className={`app-skeleton-header top-header set-y ${
          showLetNav ? 'animate-y' : ''
        }`}
      ></div>
      <div
        id="AppFrameNav"
        className={`app-skeleton-header set-x ${showLetNav ? 'animate-x' : ''}`}
      ></div>
      <div>
        <LoaderWrapper>
          <SuperOpsLoader
            color={color}
            opacity={opacity}
            height={height}
            width={width}
          />
        </LoaderWrapper>
      </div>
    </div>
  );
}

export default AppLoader;
